import React from 'react';

type Props = {
    polarAngle: number;
};

const ViewAngleIndicator = ({polarAngle}: Props) => {
    // polarAngle: 0 = top, PI/2 = side, PI = bottom
    const size = 70;
    const cx = size / 2;
    const cy = size / 2;
    const r = size / 2 - 8;

    // Elevation from horizon: 0° = side view, 90° = top view, -90° = bottom
    const elevationDeg = Math.round(90 - (polarAngle * 180 / Math.PI));

    // Calculate eye position
    // Boreholes3D version: eyeX = cx + r * Math.sin(polarAngle), eyeY = cy - r * Math.cos(polarAngle)
    // CanvasContent version: eyeAngleRad = polarAngle - Math.PI / 2; eyeX = cx + r * Math.cos(eyeAngleRad); eyeY = cy - r * Math.sin(eyeAngleRad)
    // Note: Math.cos(angle - PI/2) = Math.sin(angle)
    //       -Math.sin(angle - PI/2) = -(-Math.cos(angle)) = Math.cos(angle)
    // Wait, let's re-verify:
    // CanvasContent: eyeY = cy - r * Math.sin(polarAngle - PI/2) = cy - r * (-Math.cos(polarAngle)) = cy + r * Math.cos(polarAngle)
    // Boreholes3D: eyeY = cy - r * Math.cos(polarAngle)

    // Let's use the Boreholes3D version as it was described as placing eye at top for polar=0.
    // polar = 0: sin(0)=0, cos(0)=1 => eyeX = cx, eyeY = cy - r (Top)
    // polar = PI/2: sin(PI/2)=1, cos(PI/2)=0 => eyeX = cx + r, eyeY = cy (Right)
    const eyeX = cx + r * Math.sin(polarAngle);
    const eyeY = cy - r * Math.cos(polarAngle);

    return (
        <div className={'view-angle-indicator'}>
            <svg width={size} height={size + 10} viewBox={`0 0 ${size} ${size}`}>
                {/* Background circle */}
                <circle cx={cx} cy={cy} r={r} fill="#F5F5F5" stroke="var(--text-color)" strokeWidth={4}/>
                {/* Vertical borehole line */}
                <line x1={cx} y1={cy - r + 4} x2={cx} y2={cy + r - 4} stroke="var(--text-color-secondary)" strokeWidth={2}
                      strokeDasharray="4,2"/>
                {/* Horizon line */}
                <line x1={cx - r + 4} y1={cy} x2={cx + r - 4} y2={cy} stroke="#ccc" strokeWidth={1}/>
                {/* Line from borehole center to eye */}
                <line x1={cx} y1={cy} x2={eyeX} y2={eyeY} stroke="#2196F3" strokeWidth={1.5}/>
                {/* Eye icon */}
                <circle cx={eyeX} cy={eyeY} r={4} fill="#2196F3"/>
                {/* Elevation label */}
                <text x={cx} y={size + 5} textAnchor="middle" fontSize={10} fill="var(--text-color)">
                    {elevationDeg}°
                </text>
            </svg>
        </div>
    );
};

export default ViewAngleIndicator;
